__turbopack_context__.v({
  "content": "mobileTableStyles-module__zKaTBq__content",
  "mobileTable": "mobileTableStyles-module__zKaTBq__mobileTable",
  "row": "mobileTableStyles-module__zKaTBq__row",
  "title": "mobileTableStyles-module__zKaTBq__title",
});
